// extracted by mini-css-extract-plugin
export default {"title":"styles_title__6seIS","row":"styles_row__eUePF","code":"styles_code__6xZf+"};